/* RESPONSIBLE TEAM: team-self-serve */

import type AppService from 'embercom/services/app-service';
import Service, { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import moment from 'moment-timezone';

interface BannerMetadata {
  show: boolean;
  banner?: 'trial' | 'first-month';
  automationRate?: number;
  finIsLive?: boolean;
}

export default class CompellingOfferCampaignService extends Service {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare cardlessTrialService: $TSFixMe;
  @service declare customerService: $TSFixMe;
  @service declare aiAgentSetupService: $TSFixMe;

  get isEnrolled(): boolean {
    return this.appService.app.isForcedFreeSeatsCampaignEnrolment;
  }

  get isFreeSeatsCampaign(): boolean {
    return this.appService.app.isForcedFreeSeatsCampaignEnrolment;
  }

  /*
    There are three distinct banners or banner states:
    1. App in trial or expired trial
    2. App in first FREE_SEATS_WINDOW (30 right now) days of paid subscription
    3. App after FREE_SEATS_WINDOW days of paid subscription

    All of these conditions are gated within the campaign offer flow —
    an app has to be a part of this campaign to see these banners.
  */
  get bannerMetadata(): BannerMetadata {
    if (!this.appService.app.isForcedFreeSeatsCampaignEnrolment) {
      return { show: false };
    }

    // TODO: Wire in real automation rate from campaign metadata
    let automationRate = 0.435;
    let finIsLive = this.aiAgentSetupService.isFinLive;

    if (this.cardlessTrialService.inTrialOrExpiredTrial) {
      return { show: true, banner: 'trial', automationRate, finIsLive };
    }

    let startedAt = this.customerService.customer.subscription?.startedAt;
    let daysSinceSubscription = moment().diff(startedAt, 'days');

    if (this.customerService.customer.hasActiveSubscription && daysSinceSubscription <= 30) {
      return { show: true, banner: 'first-month', automationRate, finIsLive };
    }

    return { show: false };
  }
}

declare module '@ember/service' {
  interface Registry {
    compellingOfferCampaignService: CompellingOfferCampaignService;
    'compelling-offer-campaign-service': CompellingOfferCampaignService;
  }
}
